import { ApolloClient, ApolloLink, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

const authLink = setContext((operation, { headers }) => {
  // Skip auth ONLY for ValidateVoucher
  if (operation.operationName === 'ValidateVoucher') {
    return { headers };
  }

  const isPreview = window.location.pathname.includes('preview');
  const token = !isPreview
    ? process.env.REACT_APP_CONTENTFUL_DELIVERY_TOKEN
    : process.env.REACT_APP_CONTENTFUL_PREVIEW_TOKEN;

  return {
    headers: {
      ...headers,
      authorization: `Bearer ${token}`,
    },
  };
});

// const authLink1 = setContext((_, { headers }) => {
//   // get the authentication token from local storage if it exists
//   // const token = localStorage.getItem('token');
//   // return the headers to the context so httpLink can read them
//   const isPreview = window.location.pathname.includes('preview');
//   const token = !isPreview
//     ? process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN
//     : process.env.REACT_APP_CONTENTFUL_PREVIEW_TOKEN;
//   return {
//     headers: {
//       ...headers,
//       // authorization: `Bearer ${token}`,
//     },
//   };
// });

const httpLink = createHttpLink({
  // uri: 'http://localhost:4004/graphql',
  uri: process.env.REACT_APP_GRAPHQL_URL,
});

const client = new ApolloClient({
  // link: authLink.concat(httpLink),
  link: ApolloLink.split(
    operation => operation.getContext().skipAuth === true,
    httpLink,
    authLink.concat(httpLink)
  ),
  cache: new InMemoryCache(),
});

const httpLinkExperience = createHttpLink({
  // uri: 'http://localhost:4000/graphql',
  uri: process.env.REACT_APP_EPG_DIGITAL_API,
  headers: {
    'x-sky-app-id': 'SKY_WEB',
    'x-sky-app-version': process.env.REACT_APP_EPG_DIGITAL_API_VERSION || '1.11.29',
  },
});

const clientExperience = new ApolloClient({
  link: httpLinkExperience,
  cache: new InMemoryCache(),
  defaultOptions: {
    query: {
      fetchPolicy: 'no-cache',
    },
    watchQuery: {
      fetchPolicy: 'no-cache',
    },
  },
});

export { client, clientExperience };
